import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useProductsContext } from '../../contexts/products';
import { findProducts } from '../../api/ecDataQueryApi';
import config from '../../../preorder/configs/config';
import ProductComponent from '../product/ProductComponent';

const ProductCarouselTitle = styled.div`
  text-align: ${(props) => props.align};
  margin: 50px 0 0 0;
  position: relative;
  height: 50px;
  line-height: 50px;
  &:before{
    content: ' ';
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    top: 25px;
    background-color: black;
    z-index: -1;
  }
  & span{
    display: inline-block;
    background-color: white;
    padding: 0px 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
  }
`;

const ProductContainer = styled.div`
  white-space: nowrap;
  overflow-x: auto;
  width: calc(100% - ${(props) => (props.showMoveButtons ? '120px' : '0px')});
  min-height: 330px;
  margin: 10px 0;
  text-align: ${(props) => props.align};
  margin-left: ${(props) => (props.showMoveButtons ? '60px' : '0px')};
  margin-right: ${(props) => (props.showMoveButtons ? '60px' : '0px')};
  user-select: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar { 
      display: none;
  }
`;

const MoveButtonsContainer = styled.div`
  width: 100%;
  position: relative;
  user-select: none;
`;

const MoveLeftButton = styled.div`
  &:before{
    background-color: ${config.themeBackgroundColor};
    z-index: -1;
    content: '';
    position: absolute;
    top: 20px;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 15px;
  }
  &:after{
    width: 0; 
    height: 0; 
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent; 
    border-right: 10px solid white; 
    content: '';
    position: absolute;
    left: 4px;
    top: 24px;
  }
  position: absolute;
  margin-top: -200px;
  width: 30px;
  height: 60px;
  cursor: pointer;
  &:hover{
     opacity: 0.6;
  }
`;

const MoveRightButton = styled(MoveLeftButton)`
  right: 0;
  transform: scaleX(-1);
`;

export default ({
  name,
  products,

  showMoveButtons = true,
  align = 'center',
  titleStyle = {},
}) => {
  const {
    products: productsCache,
    addProducts,
  } = useProductsContext();

  const productsContainer = useRef(null);
  const handleMoveLeft = useCallback(() => productsContainer.current.scrollBy({ left: -100, behavior: 'smooth' }), []);
  const handleMoveRight = useCallback(() => productsContainer.current.scrollBy({ left: 100, behavior: 'smooth' }), []);

  useEffect(() => {
    (async () => {
      try {
        const missingProducts = products.filter((key) => !productsCache[key]);
        if (missingProducts.length === 0) return;
        missingProducts.forEach((key) => addProducts(key, {}));
        const productsData = await findProducts(missingProducts);
        productsData.forEach(({ key, value }) => {
          try {
            addProducts(key, JSON.parse(value));
          } catch (error) {
            console.error(error);
          }
        });
      } catch (error2) {
        console.error(error2);
      }
    })();
  }, [products]); //eslint-disable-line

  return (
    <>
      <ProductCarouselTitle align={align}>
        <span style={titleStyle}>{name}</span>
      </ProductCarouselTitle>
      <ProductContainer ref={productsContainer} align={align} showMoveButtons={showMoveButtons}>
        {
          (products || [
            Math.random(), Math.random(), Math.random(),
            Math.random(), Math.random(), Math.random(),
          ]).map((key) => {
            try {
              const productData = productsCache[key];
              return (
                <Link key={key} to={`/ec/product/${key}`}>
                  <ProductComponent data={productData} />
                </Link>
              );
            } catch (error) {
              console.error(error);
            }
            return null;
          })
        }
      </ProductContainer>
      {
        showMoveButtons && (
          <MoveButtonsContainer>
            <MoveLeftButton onClick={handleMoveLeft} />
            <MoveRightButton onClick={handleMoveRight} />
          </MoveButtonsContainer>
        )
      }
    </>
  );
};
